import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ItemDetails from '../DetailsForm';

import { SquareButton } from '../../../../Styles';
import { EditIcon } from '../../../../Styles';

const UpdateItem = ({ itemId, refresh, ...props }) => {
	const { disableSingleInventoryUpdate } = props;
	const [openUpdateSingleItem, setOpenUpdateSingleItem] = useState(false);

	return (
		<>
			{!disableSingleInventoryUpdate && (
				<SquareButton
					outline
					title={'Update Description'}
					onClick={(e) => setOpenUpdateSingleItem(true)}
				>
					<EditIcon />
				</SquareButton>
			)}

			<ItemDetails
				open={openUpdateSingleItem}
				itemId={itemId}
				onSubmit={() => {
					if (refresh) {
						refresh();
					}
				}}
				onClose={() => {
					setOpenUpdateSingleItem(false);
				}}
			/>
		</>
	);
};

const mapStateToProps = (state) => {
	const supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	const userSellerPortalConfig = state.session.sellerPortalConfig || {};

	const disableSingleInventoryUpdate = supplierSellerPortalConfig.disable_single_inventory_update || userSellerPortalConfig.disable_single_inventory_update || false;

	return {
		disableSingleInventoryUpdate,
	};
};

const mapDispatch = {};

export default withRouter(connect(mapStateToProps, mapDispatch)(UpdateItem));
